import React from 'react';
import { Badge } from 'react-bootstrap';
import { tripClaimsBadgeText, tripClaimsMessage, tripClaimsOf } from '../../Utils/tripClaims';

/**
 * "2 to review" on a booking's row (Orders, Daily Overview) while trip
 * claims wait — the counts the list carries (`trip_claims`). Opens the
 * booking's Driver events tab, where they are reviewed.
 */
function TripClaimsRowBadge({ order, onOpen, className = '' }) {
  const counts = tripClaimsOf(order);
  if (!counts.total) return null;
  return (
    <Badge
      as="button"
      type="button"
      bg="warning"
      text="dark"
      className={`border-0 ${className}`}
      title={tripClaimsMessage(counts)}
      aria-label={tripClaimsMessage(counts)}
      onClick={(event) => {
        event.stopPropagation();
        onOpen(order);
      }}
      data-testid="trip-claims-row-badge"
    >
      <i className="fa fa-receipt me-1" />
      {tripClaimsBadgeText(counts)}
    </Badge>
  );
}

export default TripClaimsRowBadge;
